export enum EModalsNames {
  CreateDebate = 'createDebate',
  AuthModal = 'authModal',
  RestorePasswordModal = 'restorePasswordModal',
  ConfirmEmailModal = 'confirmEmailModal',
  LoginModal = 'loginModal',
  PopUpNotification = 'popUpNotification',
  ChangePasswordModal = 'changePasswordModal',
  CreateDebateOptions = 'CreateDebateOptions',
  PermissionModal = 'permissionModal',
}

export enum EModalIcons {
  error = 'error',
  info = 'info',
  success = 'success',
  warning = 'warning',
}

export type TModalIcons =
  | EModalIcons.error
  | EModalIcons.info
  | EModalIcons.warning
  | EModalIcons.success;
